package app.footyguide.domain.model

import kotlinx.serialization.Serializable

/** Paleta visual canônica do time. */
@Serializable
data class TeamTheme(
    val primaryColor: String = "",
    val secondaryColor: String = "",
    val tertiaryColor: String = "",
    val isDark: Boolean = true,
)

/**
 * Modelo de um time de futebol.
 *
 * `id` canônico deve ser o slug base do time, por exemplo `flamengo`.
 */
@Serializable
data class Team(
    val id: String,
    val name: String,
    val shortName: String = "",
    val slug: String? = null,
    val nameByLocale: Map<String, String> = emptyMap(),
    val country: String,
    val competitions: List<String> = emptyList(),
    val league: String,
    val logo: String? = null,
    val theme: TeamTheme? = null,
    val primaryColor: String? = null,
    val secondaryColor: String? = null,
    val tertiaryColor: String? = null,
    val isDark: Boolean = true,
    val rivalIds: List<String> = emptyList(),
) {
    fun nameFor(language: String): String =
        nameByLocale[language] ?: name
}
